import { Component, OnInit } from '@angular/core';
import { RouterService } from '@app/routing/router.service';
import { AcdContext } from '@business/acd/models/acd-context';
import { AcdService } from '@business/acd/services/acd.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'portal-acd-sub-nav',
  templateUrl: './acd-sub-nav.component.html',
  standalone: false,
})
export class AcdSubNavComponent implements OnInit {
  acdContext$: Observable<AcdContext>;
  loading$!: Observable<boolean>;

  public routeName?: string;

  constructor(
    private acdService: AcdService,
    private routerService: RouterService
  ) {}

  ngOnInit() {
    this.acdContext$ = this.acdService.queueContext.data$.pipe(untilDestroyed(this));
    this.loading$ = this.acdService.queueContext.loading$.pipe(untilDestroyed(this));
    this.routeName = this.routerService.currentRouteData.name;
  }
}
